import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCJ6xoFEbKvX18C9BNPRAiB1ssDLD-yU5s",
  authDomain: "app.trinis.eu",
  projectId: "trinis-eu",
  storageBucket: "trinis-eu.firebasestorage.app",
  messagingSenderId: "973765550082",
  appId: "1:973765550082:web:8a0395526428334961071b",
  measurementId: "G-2D0YV7050G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check — guarded so the app runs unchanged until the operator provisions
// reCAPTCHA Enterprise. Initializes only when REACT_APP_RECAPTCHA_SITE_KEY is set;
// a REACT_APP_APPCHECK_DEBUG_TOKEN authorizes localhost/dev (one-time allowlist in
// the Firebase Console). Server callables enforce only once APP_CHECK_ENFORCE=true.
const appCheckSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (appCheckSiteKey) {
  const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  if (debugToken) {
    (globalThis as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: string })
      .FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default app;